import { render, staticRenderFns } from "./priceRangeNew.vue?vue&type=template&id=820cde64&scoped=true"
import script from "./priceRangeNew.vue?vue&type=script&lang=js"
export * from "./priceRangeNew.vue?vue&type=script&lang=js"
import style0 from "./priceRangeNew.vue?vue&type=style&index=0&id=820cde64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820cde64",
  null
  
)

export default component.exports